<div class="mt3 center col-10 md-col-8 mx-auto">
    <h1>Oops!</h1>
    <h2>404 Not Found</h2>
    <div>Sorry, an error has occured, Requested page not found!</div>
    <a class="col-2 mt3" mat-raised-button [routerLink]="'/start'">Go Home</a>
</div>